import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VexModule } from '../@vex/vex.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CustomLayoutModule } from './custom-layout/custom-layout.module';
import { ToastrModule } from 'ngx-toastr';
import {HashLocationStrategy,LocationStrategy} from '@angular/common';
import { NgxLoadingModule } from 'ngx-loading';

import { LoaderInterceptor } from './loader.interceptor';
import { LoaderComponent } from './loader/loader.component';
import { RecargaDirective } from './Directive/recarga.directive';
// 2FA
import { LoginModule, provideBovedaLogin } from 'login-angular13';
import { environment } from '../environments/environment';
import { BovedaAuthService, BovedaUtilService } from './services/boveda-integration.service';


@NgModule({
  declarations: [AppComponent, LoaderComponent, RecargaDirective],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
    // Vex
    VexModule,
    CustomLayoutModule,
    NgxLoadingModule.forRoot({}),
    LoginModule

  ],
  providers: [{provide:LocationStrategy, useClass:HashLocationStrategy},
    {
    provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true
  }, provideBovedaLogin(environment.login, {authService: BovedaAuthService, utilService: BovedaUtilService,})],
  bootstrap: [AppComponent]
})
export class AppModule { }
